export default [
  {
    title: 'breadcrumb.requestDeposit',
    route: 'request-deposit',
    icon: 'TrendingUpIcon',
    resource: 'request-deposit',
    action: 'read',
    tag: 0,
  },
]
